<div class="content-container">
    <div class="container">
        <div class="row justify-content-md-center">
            <div class="col-24 col-lg-20 col-xl-16">
                <div class="d-flex justify-content-center mb-2 d-sm-none">
                    <app-contact-photo [contact]="contact" />
                </div>

                <div class="d-flex">
                    <app-contact-photo [contact]="contact" class="d-none d-sm-flex" />
                    <div>
                        <h2>
                            {{ contact.name }}
                        </h2>
                        <p>
                            <span class="fw-bold">Telefoonnummer: </span>
                            <a href="tel:{{ contact.phone }}">{{ contact.phone }}</a>
                        </p>
                        <p>
                            <span class="fw-bold">E-mailadres: </span>
                            <a href="mailto:{{ contact.email }}">{{ contact.email }}</a>
                        </p>
                        <p>
                            {{ contact.description }}
                        </p>
                    </div>
                </div>
                @if (Features.CustomersDetailContactsSave | hasFeature) {
                    <div class="d-flex justify-content-end">
                        <button
                            color="primary"
                            mat-raised-button
                            routerLink="/{{ Routenames.customers }}/{{ customerId }}/{{ Routenames.projects }}/{{
                                projectId
                            }}/{{ Routenames.contacts }}/{{ contact.id }}/{{ Routenames.edit }}">
                            Contactpersoon aanpassen
                        </button>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
